import { JSX } from 'react'

import { Box, Image, Separator } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request'

import * as locally from '@/lib/locally.js'

import * as archive_storage from '@/storage/archive.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export default function
(
	props: {
		doc: HttpBody<archive_storage.TRawDocumentType>

	},

)
:	JSX.Element
{
	let { name, birthday, sex, ethnicity, identity, issue, valid, address } = props.doc

	let data: Array<[string, number | string]> = [
		['姓名', name],
		['出生日期', locally.date(birthday, { format: 'YYYY.MM.DD' })],
		['性别', sex],
		['民族', ethnicity],
		['身份证号码', identity],
		['签发机关', issue],
		['有效期', valid.map(v => locally.date(v, { format: 'YYYY.MM.DD' }) ).join(' 至 ')],
		['证件地址', address],

	]

	return (
		<Box w="72" p="2">
			<Image w="full" rounded="xl" aspectRatio="square" src={props.doc.idcard} />

			<Separator mt="6" />

			<Fieldset.List mt="6" name="基本信息" data={data} />

		</Box>

	)

}
